import React, { CSSProperties, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Card, Col, Row, Spin } from 'antd';

const BillDetailsCard: React.FC = () => {
    const [loading, setLoading] = useState(true);
  const claimDetails: any = useSelector(
    (state: RootState) => state?.claimsDetails?.claimDetails,
  );
  const cardHeaderStyle: CSSProperties = {
    background: '#E9ECF0',
    color: 'black',
    padding: '12px',
    textAlign: 'center',
  };

  useEffect(() => {
    // creating a delay
    setTimeout(() => {
        setLoading(false);
    }, 2000);
  }, []);
  return (
    <div style={{width: '80vw', paddingLeft: '70px'}}>
        <Spin spinning = {loading}>
        <Card title = "Bill Details" headStyle={cardHeaderStyle}>
            <Row gutter={[16, 16]}>
                <Col span={6}>
                    <label>Package</label>
                    <div>Rs.{claimDetails?.claimBillDetails?.[0]?.billAmount}/-</div>
                </Col>
                <Col span={6}>
                    <label>Room Rent & Nursing Charges</label>
                    <div>Rs.{claimDetails?.hospitalRoomType?.[0]?.roomRent}</div>
                </Col>
                <Col span={6}>
                    <label>Consultation Charges</label>
                    <div>{}</div>
                </Col>
                <Col span={6}>
                    <label>OT Charges</label>
                    <div>{}</div>
                </Col>
            </Row>
            <br/>
            <Row gutter={[16, 16]}>
                <Col span={6}>
                    <label>Surgeon & anesthetist</label>
                    <div>{}</div>
                </Col>
                <Col span={6}>
                    <label>Investigation</label>
                    <div>{}</div>
                </Col>
                <Col span={6}>
                    <label>Medicine & Consumables</label>
                    <div>{}</div>
                </Col>
                <Col span={6}>
                    <label>Other Hospital Expenses</label>
                    <div>{}</div>
                </Col>
            </Row>
            <br/>
            <Row gutter={[16, 16]}>
                <Col span={6}>
                    <label>Total</label>
                    <div>Rs.{claimDetails?.claimBillDetails?.[0]?.billAmount}</div>
                </Col>
            </Row>
        </Card>
        </Spin>
    </div>
  );
};

export default BillDetailsCard;
